import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';

import { APPLICATION_SLICE_NAME, APPLICATION_INITIAL_STATE } from './consts';
import type { ApplicationState, AppStatus } from './types';

const applicationSlice = createSlice({
  name: APPLICATION_SLICE_NAME,
  initialState: APPLICATION_INITIAL_STATE,
  reducers: {
    setAppInitialized: (state) => {
      state.appInitialized = true;
    },

    setAppBanned: (state, action: PayloadAction<boolean>) => {
      state.appBanned = action.payload;
    },

    setCaptchaToken: (state, action: PayloadAction<string | null>) => {
      state.captchaToken = action.payload;
    },

    setAuthToken: (state, action: PayloadAction<string | undefined>) => {
      const wasLoggedIn = !!state.authToken;
      state.authToken = action.payload;
      if (action.payload) {
        state.appStatus = 'initializing';
      } else if (wasLoggedIn) {
        state.appStatus = 'loggingOut';
      }
    },

    setAppStatus: (state, action: PayloadAction<AppStatus>) => {
      state.appStatus = action.payload;
    },

    bootApp: () => {},
  },
});

export const { setAppInitialized, setAppBanned, setCaptchaToken, setAuthToken, setAppStatus, bootApp } =
  applicationSlice.actions;

export const applicationReducer: Reducer<ApplicationState> = applicationSlice.reducer;
